import { ManagePayee } from "../../../Pages/Manage Payee";

import { modalVariants } from "../../../Utils/constants";

export default function renderSelectDestinationAccount(modalContext, props) {
  const { updateModalComponent, setModalClassName, pushModalStack, setModalVariant, setModalTitle } = modalContext;

  pushModalStack(() => renderSelectDestinationAccount(modalContext, props));
  updateModalComponent(() => <ManagePayee presentedForSelection {...props} />);
  setModalTitle("Select Destination Account");
  setModalClassName("rendering-page-content");
  setModalVariant(modalVariants.formDialog);
}
